import { call, put, takeLatest } from 'redux-saga/effects';
import handleException from '../services/handleException';
import { getListCurrency } from '../utils/getListCurrency';
import { GET_LIST_CURRENCY, GET_LIST_CURRENCY_SUCCESS } from './../actions/getListCurrency';

function* getlistCurrencySaga() {
    yield takeLatest(GET_LIST_CURRENCY, getListCurrencyHandle)
}

function* getListCurrencyHandle(action) {
    try {
        const response = yield call(getListCurrency, action.payload)

        if (response.data.code === 200) {
            yield put({ type: GET_LIST_CURRENCY_SUCCESS, payload: response })
        } else {
            handleException(response)
        }
    } catch (error) {
        handleException(error)
    }
}

export default getlistCurrencySaga


// WEBPACK FOOTER //
// ./src/sagas/getListCurrencySaga.js